import React, { useState, useEffect } from 'react';
import { Button, Modal, Space } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Update UI to notify the user they can add to home screen
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    // We no longer need the prompt. Clear it up
    setDeferredPrompt(null);

    // Hide the install button
    setShowInstallButton(false);

    // Show modal based on outcome
    if (outcome === 'accepted') {
      setIsModalVisible(true);
    }
  };

  const handleCancel = () => {
    setShowInstallButton(false);
    setDeferredPrompt(null);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  if (!showInstallButton) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: '8px'
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            maxWidth: '300px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '500' }}>Install Our App</h3>
            <Button 
              type="text" 
              icon={<CloseOutlined />} 
              onClick={handleCancel}
              style={{ padding: '4px' }}
            />
          </div>
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
            Install our app for a better experience and offline access.
          </p>
          <Space>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={handleInstallClick}
              style={{
                height: '40px',
                padding: '0 20px',
                borderRadius: '20px',
                background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                border: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.3s ease'
              }}
            >
              Install Now
            </Button>
            <Button
              onClick={handleCancel}
              style={{
                height: '40px',
                padding: '0 20px',
                borderRadius: '20px',
                border: '1px solid #d9d9d9',
                background: 'white',
                color: '#666',
                transition: 'all 0.3s ease'
              }}
            >
              Maybe Later
            </Button>
          </Space>
        </div>
      </div>

      <Modal
        title="App Installed Successfully!"
        open={isModalVisible}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={[
          <Button 
            key="ok" 
            type="primary" 
            onClick={handleModalClose}
            style={{
              background: 'linear-gradient(45deg, #1890ff, #722ed1)',
              border: 'none'
            }}
          >
            OK
          </Button>
        ]}
      >
        <p>Thank you for installing our app! You can now access it from your home screen.</p>
      </Modal>
    </>
  );
};

export default InstallPWA; 